import { Heading, Spacer, Switch } from '@sparemin/blockhead';
import React from 'react';
import { useSelector } from 'react-redux';
import InputLabel from 'components/Form/InputLabel';
import ShareFormGroup from 'components/ShareForm/ShareFormGroup';
import BlueskyCustomReplyAudiences from 'containers/BlueskyPostModal/BlueskyCustomReplyAudiences';
import BlueskyReplyLevelSelector from 'containers/BlueskyPostModal/BlueskyReplyLevelSelector';
import SocialShareModalAICaptionsField from 'containers/SocialShareModal/SocialShareModalAICaptionsField';
import SocialShareModalBody from 'containers/SocialShareModal/SocialShareModalBody';
import { useSocialShareModal } from 'containers/SocialShareModal/SocialShareModalContext';
import useSocialPostShareStatus from 'containers/SocialShareModal/SocialSharePlatforms/useSocialPostShareStatus';
import {
  BlueskyCustomReplyAudience,
  BlueskyReplyLevel,
} from 'redux/middleware/api/podcast-service';
import { blueskyIsPostingSelector } from 'redux/modules/social';
import { socialShareModalBlock as block } from '../../../../utils';
import { BLUESKY_MAX_DESCRIPTION_CHARS } from './constants';

export type BlueskyPostComposerStepProps = {
  allowQuotePost: boolean;
  replyLevel: BlueskyReplyLevel;
  customReplyAudiences: BlueskyCustomReplyAudience[];
  onToggleAllowQuotePost: (allowQuotePost: boolean) => void;
  onReplyLevelChange: (replyLevel: BlueskyReplyLevel) => void;
  onChangeCustomReplyAudiences: (value: BlueskyCustomReplyAudience[]) => void;
};

const BlueskyPostComposerStep: React.FC<BlueskyPostComposerStepProps> = ({
  allowQuotePost,
  replyLevel,
  customReplyAudiences,
  onToggleAllowQuotePost,
  onReplyLevelChange,
  onChangeCustomReplyAudiences,
}) => {
  const isPosting = useSelector(blueskyIsPostingSelector);

  const { description, setDescription } = useSocialShareModal();

  useSocialPostShareStatus({
    onSuccess: () => {
      onToggleAllowQuotePost(true);
      onReplyLevelChange('everybody');
      onChangeCustomReplyAudiences([]);
    },
  });

  return (
    <SocialShareModalBody loadingTitle="Posting Video" isLoading={isPosting}>
      <SocialShareModalAICaptionsField
        inputProps={{
          value: description,
          maxChars: BLUESKY_MAX_DESCRIPTION_CHARS,
          onChange: setDescription,
        }}
      />

      <ShareFormGroup className={block('share-form-group')}>
        <InputLabel className={block('bluesky-input-label')}>
          Quote settings:
        </InputLabel>

        <Spacer
          space="8px"
          orientation="horizontal"
          align="center"
          justify="flex-start"
        >
          <Heading level={4}>Allow quote posts</Heading>

          <Switch
            isSelected={allowQuotePost}
            className={block('bluesky-allow-quote-switch')}
            onChange={onToggleAllowQuotePost}
          />
        </Spacer>
      </ShareFormGroup>

      <Spacer
        space="16px"
        orientation="vertical"
        className={block('bluesky-reply-settings')}
      >
        <BlueskyReplyLevelSelector
          value={replyLevel}
          onChange={onReplyLevelChange}
        />

        <BlueskyCustomReplyAudiences
          value={customReplyAudiences}
          onChange={onChangeCustomReplyAudiences}
        />
      </Spacer>
    </SocialShareModalBody>
  );
};

export default BlueskyPostComposerStep;
